import { faCircleMinus, faCirclePlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FC, SyntheticEvent } from 'react';

interface ExpandColumnCellProps {
  expand: boolean;
  onExpand: (e?: SyntheticEvent) => void;
  plusIconColor?: string;
  minusIconColor?: string;
  title?: string;
}

const ExpandCollapseCell: FC<ExpandColumnCellProps> = ({
  expand,
  onExpand,
  plusIconColor,
  minusIconColor,
  title,
}) => (
  <div
    className="flex justify-center items-center pl-2 pr-2 hover:cursor-pointer"
    onClick={onExpand}
    id="expandIcon"
    data-tooltip-id="global-tooltip"
    data-tooltip-content={title}
  >
    {expand ? (
      <FontAwesomeIcon icon={faCircleMinus} color={plusIconColor} size="lg" />
    ) : (
      <FontAwesomeIcon icon={faCirclePlus} color={minusIconColor} size="lg" />
    )}
  </div>
);

export default ExpandCollapseCell;
